import Formatter from '~/plugins/i18n/formatter'
import missingHandler from '~/plugins/i18n/missingHandler'

export default ({ $envConfig }) => {
  return {
    fallbackLocale: 'en',
    formatter: new Formatter($envConfig.i18n),
    missing: missingHandler
  }
}
